export default __webpack_public_path__ + "static/media/appliances.15f899d5.PNG";